import type { MedicalAid } from '@quromedical/models';
import { FormCard, type RowConfig } from 'design-system';
import type React from 'react';
import { strings } from 'strings';

const createMedicalAidRowConfigs = (
  medicalAid?: Partial<MedicalAid>,
): RowConfig[] => [
  {
    fields: [
      {
        type: 'text',
        label: strings.CardLabelScheme,
        display: medicalAid?.schemeName,
      },
      {
        type: 'text',
        label: strings.CardLabelPlanAndOption,
        display: medicalAid?.plan,
      },
    ],
  },
  {
    fields: [
      {
        type: 'text',
        label: strings.FormLabelMedicalAidNumber,
        display: medicalAid?.membershipNumber,
      },
    ],
  },
];

export const MedicalAidMembershipCard: React.FC<Partial<MedicalAid>> = (
  props,
) => {
  const medicalAidRowConfigs = createMedicalAidRowConfigs(props);

  return (
    <FormCard
      title={strings.CardLabelMedicalAidDetails}
      rows={medicalAidRowConfigs}
      showIcons={false}
    />
  );
};
